import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import jwt_decode from 'jwt-decode';

interface JwtPayload {
    iss?: string;
    sub?: string;
    aud?: string[] | string;
    exp: number;
    nbf?: number;
    iat?: number;
    jti?: string;
  }

const PrivateRoute = ({ component: Component, ...rest }: any) => {
    let loggedIn : Boolean = true;

    try{
        const DecodedToken = jwt_decode(localStorage.getItem("token") as string) as JwtPayload;
        const ExpirationTime = DecodedToken.exp * 1000;
        loggedIn = Date.now() < ExpirationTime && DecodedToken.iss == "Uniplay web API";
    }
    catch
    {
        loggedIn = false;
    }

  return (
    <Route
      {...rest}
      render={(props) =>
        loggedIn ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default PrivateRoute;
